import { render, staticRenderFns } from "./dev-account.vue?vue&type=template&id=5094309e&scoped=true"
import script from "./dev-account.vue?vue&type=script&lang=js"
export * from "./dev-account.vue?vue&type=script&lang=js"
import style0 from "./dev-account.vue?vue&type=style&index=0&id=5094309e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5094309e",
  null
  
)

export default component.exports